// @ts-nocheck

export const masks = {
  unmask: (value) => value.replace(/[^a-zA-Z0-9]/g, ''),
  number: (value) => String(value).replace(/\D/g, ''),
  text: (value) => String(value).replace(/\d/g, ''),
  state: (value) => value.replace(/\d/, ''),
  hour: (value) =>
    String(value)
      .replace(/\D/, '')
      .replace(/(\d{2})(\d)/, '$1:$2'),
  showHour: (value) => {
    value = String(value)
    return value.length === 3
      ? value.replace(/(\d{1})(\d)/, '$1h$2')
      : value.replace(/(\d{2})(\d)/, '$1h$2')
  },
  cpf: (value) => {
    if (!value) return "";
    return value
      .replace(/\D/g, '')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1')
  },
  date: (string = '') => {
    if (isIsoDate(string)) {
      const date = new Date(string)
      const day = date.getDate()
      const month = date.getMonth() + 1
      const year = date.getFullYear()
      return `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`
    }

    return string
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '$1/$2')
      .replace(/(\d{2})(\d)/, '$1/$2')
      .replace(/(\d{4})(\d)/, '$1')
  },
  rg: (value) =>
    value
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{1})\d+?$/, '$1'),
  cnpj: (value) =>
    value
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1/$2')
      .replace(/(\d{4})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1'),
  zipcode: (value) =>
    value
      .replace(/\D/g, '')
      .replace(/(\d{5})(\d)/, '$1-$2')
      .replace(/(-\d{3})\d+?$/, '$1'),
  phone: (string) => {
    if (!string) return "";
    const value = string.replace(/\D/g, '')

    if (value.length >= 11)
      return value
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{5})(\d)/, '$1-$2')
        .replace(/(-\d{4})\d+?$/, '$1')

    return value
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d)/, '$1-$2')
      .replace(/(-\d{4})\d+?$/, '$1')
  },

  cell: (value) =>
    value
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{5})(\d)/, '$1-$2')
      .replace(/(-\d{4})\d+?$/, '$1'),
  currency: (value) => {
    if (value) {
      const string = value.toString()

      if (string.replace(/\D/g, '') !== '') {
        const amount = (
          parseInt(string.replace(/\D/g, ''), 10) / 100
        ).toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
          style: 'currency',
          currency: 'BRL',
        })

        return value < 0 ? `-${amount}` : amount
      }
    }

    return '0,00'
  },
  currencyAllPlatforms: (value) => {
    if (Number(value)) {
      const [currency, cents] = (Number(value) / 100)
        .toFixed(2)
        .toString()
        .split('.')

      return `R$ ${currency.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${cents}`
    }

    return 'R$ 0,00'
  },
  percentage: (value) => {
    let number = Number(String(value).replace(/\D/g, ''))
    if (number > 100) number = 100
    return `${number}`
  },
  creditCard: (value) =>
    value
      .replace(/\D/g, '')
      .replace(/(\d{4})(\d)/, '$1 $2')
      .replace(/(\d{4})(\d)/, '$1 $2')
      .replace(/(\d{4})(\d)/, '$1 $2')
      .replace(/(.\d{4})\d+?$/, '$1'),

  creditCardDate: (value) => {
    value = value
      .replace(/\D/g, '')
      .replace(/([\d]{4})/, '$1')
      .replace(/([\d]{4})[\d]+?$/, '$1')
      .replace(/([\d]{2})([\d]{1})/, '$1/$2')
    const dates = value.split('/')
    if (dates.length) {
      if (parseInt(dates[0], 10) > 12) dates[0] = '12'
      return dates.join('/')
    }
    return value
  },
  cvv: (value) =>
    value
      .replace(/[^\d]/g, '')
      .replace(/([\d]{4})/, '$1')
      .replace(/([\d]{4})[\d]+?$/, '$1'),
  bankAgency: (value) =>
    value
      .replace(/[\D]/g, '')
      .replace(/([\d]{4})/, '$1')
      .replace(/([\d]{4})[\d]+?$/, '$1'),

  bankAccount: (value) =>
    value
      .replace(/[^\d^\-]/g, '')
      .replace(/([\d]+)/, '$1')
      .replace(/([\d]+)-([\d]{1})+?$/, '$1-$2'),
}

masks.cpfOrCnpj = (string) => {
  const value = masks.unmask(string)

  if (value.length > 11) {
    return masks.cnpj(value)
  }

  return masks.cpf(value)
}

function isIsoDate(str: string) {
  if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str)) return false
  const d = new Date(str)
  return d instanceof Date && !isNaN(d.getTime()) && d.toISOString() === str // valid date
}

export function applyMask(
  maskFn: (v: any) => string,
  unmaskFn?: (v: any) => string,
) {
  return (e: ChangeEvent<HTMLInputElement>) => {
    if (!maskFn) return e.target.value
    const value = e.target.value
    e.target.value = maskFn((unmaskFn || masks.unmask)(value))
  }
}

export default masks
